import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const SuccessModal = ({ isOpen, email }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-card rounded-xl p-6 md:p-8 lg:p-10 max-w-md w-full border border-border shadow-warm-xl animate-in fade-in zoom-in duration-300">
        <div className="text-center">
          <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-success/10 flex items-center justify-center mx-auto mb-4 md:mb-6">
            <Icon name="CheckCircle" size={40} color="var(--color-success)" />
          </div>

          <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-3">
            Registration Successful!
          </h2>

          <p className="text-sm md:text-base text-muted-foreground mb-6">
            Welcome to Maladapted Miscreants! We've sent a verification email to:
          </p>

          <div className="bg-muted/50 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-center gap-2">
              <Icon name="Mail" size={18} color="var(--color-accent)" />
              <span className="text-sm md:text-base font-medium text-foreground break-all">
                {email}
              </span>
            </div>
          </div>

          <div className="space-y-3 mb-6">
            <div className="flex items-start gap-3 text-left">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-1" />
              <p className="text-sm text-muted-foreground">
                Click the verification link in your email to activate your account
              </p>
            </div>
            <div className="flex items-start gap-3 text-left">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-1" />
              <p className="text-sm text-muted-foreground">
                Your account will be reviewed by guild officers within 24-48 hours
              </p>
            </div>
            <div className="flex items-start gap-3 text-left">
              <Icon name="Check" size={16} color="var(--color-success)" className="flex-shrink-0 mt-1" />
              <p className="text-sm text-muted-foreground">
                You'll receive a confirmation email once approved
              </p>
            </div>
          </div>

          <Button
            variant="default"
            size="lg"
            fullWidth
            iconName="ArrowRight"
            iconPosition="right"
            onClick={() => navigate('/guild-dashboard')}
          >
            Go to Dashboard
          </Button>

          <p className="text-xs text-muted-foreground mt-4">
            Didn't receive the email? Check your spam folder or contact a guild officer
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;